import {App, Button as AntButton} from "antd";
import {configConfirmModal} from "@/theme";
import {ButtonProps} from "antd/es/button/button";

type ButtonType = ButtonProps & {
    onClick?: () => void,
    confirm?: boolean | object
}

export const Button = ({onClick, confirm = false, ...rest}: ButtonType) => {
    const {modal} = App.useApp();

    return (
        <AntButton
            {...rest}
            onClick={async () => {
                if (confirm){
                    // @ts-ignore
                    modal.confirm(configConfirmModal({
                        // @ts-ignore
                        ...confirm,
                        onOk: () =>{
                            if (onClick){
                                onClick()
                            }
                        }
                    }))
                }else {
                    if (onClick){
                        onClick()
                    }
                }
            }}
        />
    );
}